import { Box, styled } from "@mui/material";

const Item = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "1rem",
});

export default Item;
